// @ts-nocheck
import { useState } from 'react';
import { USER_FROM_TOKEN_API } from 'config/constants';
import useGet from './useGet';
import useUser from './useUser';
// import useAnalytics from './useAnalytics';
import useSave from './useSave';
import useGetWithRetries from './useGetWithRetries';

function useAuth() {
  const { user, setUser, setStonlyData, setTenantInformation } = useUser();
  const token = localStorage.getItem('token');
  const userExists = !!user && !!token;

  const [isAuthenticated, setIsAuthenticated] = useState(userExists);
  const [loading, setLoading] = useState(!userExists);
  // const { identify } = useAnalytics();

  const [postForAccessToken] = useSave('v1.1/token/refresh/');

  // useEffect(() => {
  // if (isAuthenticated) identify();

  // }, [isAuthenticated]);

  useGet('v1.1/stonly/', {
    onSuccess(data) {
      setStonlyData(data);
    },
  });

  const { fetch: fetchTenantInformation, loading: loadingTenantInformation } =
    useGet('v1.1/tenant/', {
      onSuccess(data) {
        setTenantInformation(data);
        if (!localStorage.getItem('tenant')) {
          localStorage.setItem('tenant', data[0]?.id);
        }
      },
    });

  useGetWithRetries(USER_FROM_TOKEN_API, {
    skip: userExists,
    transformSuccess(res) {
      return {
        ...res.data,
        initials: `${res.data.first_name?.charAt(
          0,
        )}${res.data.last_name?.charAt(0)}`,
        id: res.data.user_id,
      };
    },
    onSuccess(data) {
      setUser(data);
      setIsAuthenticated(true);
      setLoading(false);
    },
    onFailure() {
      localStorage.removeItem('token');
      localStorage.removeItem('refresh');
      setUser(null);
      setIsAuthenticated(false);
      setLoading(false);
    },
  });

  return {
    isAuthenticated,
    loading,
    postForAccessToken,
    fetchTenantInformation,
    loadingTenantInformation,
    setIsAuthenticated,
  };
}

export default useAuth;
